import { Field } from '@base-ui/react';
import { FC, MouseEvent } from 'react';

import HelperDescription from '../Helper/HelperDescription';
import Label from '../Label';
import {
  StyledBox,
  StyledEndControlWrapper,
  StyledIconWrapper,
  StyledInput,
  StyledRoot,
} from './Input.styled';
import type { InputProps } from './types';

const focusControlFromField = (event: MouseEvent<HTMLDivElement>) => {
  if (event.target !== event.currentTarget) return;
  event.preventDefault();
  event.currentTarget.querySelector('input')?.focus();
};

const Input: FC<InputProps> = ({
  size = 'md',
  label,
  required,
  optional,
  tooltip,
  topRightLabel,
  helperText,
  state = 'default',
  iconStart,
  startIcon,
  endIcon,
  endControl,
  disabled,
  containerClassName,
  changed,
  ...rest
}) => (
  <StyledRoot
    disabled={disabled}
    invalid={state === 'destructive'}
    className={containerClassName}
    data-changed={changed ? 'true' : undefined}
  >
    {label && (
      <Field.Label
        render={
          <Label
            required={required}
            optional={optional}
            tooltip={tooltip}
            topRightLabel={topRightLabel}
          >
            {label}
          </Label>
        }
      />
    )}
    <StyledBox $size={size} $state={state} onMouseDown={focusControlFromField}>
      {startIcon && <StyledIconWrapper>{startIcon}</StyledIconWrapper>}
      <StyledInput $size={size} disabled={disabled} {...rest} />
      {endIcon && <StyledIconWrapper>{endIcon}</StyledIconWrapper>}
      {endControl && (
        <StyledEndControlWrapper data-end-control>{endControl}</StyledEndControlWrapper>
      )}
    </StyledBox>
    <HelperDescription state={state} iconStart={iconStart} label={helperText} />
  </StyledRoot>
);

Input.displayName = 'Input';

export default Input;
